import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import Intake, { DispatchProps, OwnProps, StateProps } from './IntakeTab';
import { StoreState } from 'src/store/reducers';
import { createIntakesStudent, getIntakes } from '../../../../../../../../store/actions/student-actions';
import { toast } from 'react-toastify';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        intakes: state.students.currentIntakes,
        inProgress: state.students.inProgressIntake,
        inProgressIntakeSent: state.intakeSents.inProgress,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getIntakes: (id: string | number) => dispatch(getIntakes(id)),
        uploadIntakes: (id: string | number, requestType: string, files: any, setLoad: any) =>
            dispatch(
                createIntakesStudent(
                    id,
                    requestType,
                    files,
                    setLoad,
                    () => {
                        toast.success('The data was added successfully');
                        setLoad(false);
                    },
                    (errorMessage: string) => {
                        toast.error(errorMessage);
                    },
                ),
            ),
    };
}

const IntakeTab = connect<StateProps, DispatchProps, OwnProps, StoreState>(mapStateToProps, mapDispatchToProps)(Intake);

export default IntakeTab;
